// src/com/veh_info/VehInfoDict.js
import { InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";
import ValueMisc from "../../value/ValueMisc";


const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    vehInfoSeq : {
		id: 'vehInfoSeq', label: '차량지정',
		type: InputType.number, required: true, toAdd: false, toEdit: true,
		check: (value) => {return value > 0 && value <= 9999999999},
	}, // int(11)
    comId : {
		id: 'comId', label: '운송사코드',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '10자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 10)},
	}, // varchar(10)
    vehId : {
		id: 'vehId', label: 'vehId',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // int(11)
    vehPlates : {
		id: 'vehPlates', label: '차량번호',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '20자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 20)},
	}, // varchar(20)
    vehAlias : {
		id: 'vehAlias', label: '지도표시명',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '20자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 20)},
	}, // varchar(20)
    rentYn : {
		id: 'rentYn', label: '용차여부',
		type: InputType.checkbox, required: false, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
		trueValue: 'Y', falseValue: 'N',
	}, // enum('Y','N')
    termId : {
		id: 'termId', label: '단말기',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '14자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 14)},
	}, // varchar(14)
    vehTypeName : {
		id: 'vehTypeName', label: '차종',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '50자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 50)},
	}, // varchar(50)
    vehTonName : {
		id: 'vehTonName', label: '톤수',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '30자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 30)},
	}, // varchar(30)
    driverName : {
		id: 'driverName', label: '운전자',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '64자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 64)},
	}, // varchar(64)
    driverMobile : {
		id: 'driverMobile', label: '휴대전화',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '256자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 256)},
	}, // varchar(256)
    termPowerCd : {
		id: 'termPowerCd', label: '단말기전원',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '12자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 12)},
	}, // varchar(12)
    doorSensors : {
		id: 'doorSensors', label: '도어센서',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '20자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 20)},
	}, // varchar(20)
    operFontColor : {
		id: 'operFontColor', label: '운행전경색',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '7자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 7)},
	}, // varchar(7)
    operBackColor : {
		id: 'operBackColor', label: '운행배경색',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '7자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 7)},
	}, // varchar(7)
    noOperFontColor : {
		id: 'noOperFontColor', label: '정차전경색',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '7자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 7)},
	}, // varchar(7)
    noOperBackColor : {
		id: 'noOperBackColor', label: '정차배경색',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '7자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 7)},
	}, // varchar(7)
    emerFontColor : {
		id: 'emerFontColor', label: '비상전경색',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '7자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 7)},
	}, // varchar(7)
    emerBackColor : {
		id: 'emerBackColor', label: '비상배경색',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '7자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 7)},
	}, // varchar(7)
    offFontColor : {
		id: 'offFontColor', label: '단말기차단전경색',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '7자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 7)},
	}, // varchar(7)
    offBackColor : {
		id: 'offBackColor', label: '단말기차단배경색',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '20자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 20)},
	}, // varchar(20)
    /* syncTime : {
		id: 'syncTime', label: 'syncTime',
		type: InputType.datetime, required: false, toAdd: true, toEdit: true,
	}, // timestamp */
    transPosYn : {
		id: 'transPosYn', label: 'transPosYn',
		type: InputType.checkbox, required: false, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
		trueValue: 'Y', falseValue: 'N',
	}, // enum('Y','N')
    comName : {
		id: 'comName', label: '운송사',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '30자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 30)},
	}, // varchar(30)
    dcCd : {
		id: 'dcCd', label: 'DC코드',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '3자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 3)},
	}, // varchar(3)
    dcName : {
		id: 'dcName', label: '소속센터',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '20자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 20)},
	}, // varchar(20)
    
};

const RentalDict = {
    vehInfoSeq : Dict.vehInfoSeq,
    vehPlates : Dict.vehPlates,
    vehTypeName : Dict.vehTypeName,
    vehTonName : Dict.vehTonName,
    driverName : Dict.driverName,
    driverMobile : Dict.driverMobile,
};
/**
 * VEH_INFO React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-10-07 13:30:46 using DbdbTap
 */
export const VehInfoDictionary = {
    inputMap: RentalDict,
    errorTitle: {
        Add: '차량정보 등록 오류',
        Edit: '차량정보 수정 오류',
        Remove: '차량정보 삭제 오류',
        Get: '차량목록 조회 오류',
    },
    tableProps: {
        tableId: 'vehInfoTable',
        uniqueKey: 'vehInfoSeq',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            //{ id: 'vehInfoSeq', label: Dict.vehInfoSeq.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            //{ id: 'comId', label: Dict.comId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'vehId', label: Dict.vehId.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'vehPlates', label: Dict.vehPlates.label, width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'vehAlias', label: Dict.vehAlias.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'dcName', label: Dict.dcName.label, width: 90, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'comName', label: Dict.comName.label, width: 130, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'rentYn', label: '사용구분', width: 80, show: true, option:{align: 'center', print:(r,i,v)=>v==='Y' ? '용차' : '고정차'} },
            //{ id: 'termId', label: Dict.termId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehTypeName', label: Dict.vehTypeName.label, width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehTonName', label: Dict.vehTonName.label, width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'driverName', label: Dict.driverName.label, width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'gpsTime', label: '최종위치보고', width: 160, show: true, option:{align: 'center', print:(r,i,v)=>v?v.substring(0,16):'-'} },
            //{ id: 'driverMobile', label: Dict.driverMobile.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            /* { id: 'termPowerCd', label: Dict.termPowerCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'doorSensors', label: Dict.doorSensors.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'operFontColor', label: Dict.operFontColor.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'operBackColor', label: Dict.operBackColor.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'noOperFontColor', label: Dict.noOperFontColor.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'noOperBackColor', label: Dict.noOperBackColor.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'emerFontColor', label: Dict.emerFontColor.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'emerBackColor', label: Dict.emerBackColor.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'offFontColor', label: Dict.offFontColor.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'offBackColor', label: Dict.offBackColor.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'syncTime', label: Dict.syncTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
             */
            { id: 'regDate', label: "등록일", width: 120, show: true, option:{align: 'center', print:(r,i,v)=>v?v.substring(0,10):'-'} },
            //{ id: 'regUser', label: "regUser", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'transPosYn', label: Dict.transPosYn.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'dcCd', label: Dict.dcCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            
        ]
    },
    myDcRentTableProps: {
        tableId: 'vehInfoMyDcRentTable',
        uniqueKey: 'vehInfoSeq',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            //{ id: 'vehInfoSeq', label: Dict.vehInfoSeq.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            //{ id: 'comId', label: Dict.comId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'vehId', label: Dict.vehId.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'comName', label: Dict.comName.label, width: 130, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehPlates', label: Dict.vehPlates.label, width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehAlias', label: Dict.vehAlias.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'dcName', label: Dict.dcName.label, width: 90, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'rentYn', label: '사용구분', width: 80, show: true, option:{align: 'center', print:(r,i,v)=>v==='Y' ? '용차' : '고정차'} },
            //{ id: 'termId', label: Dict.termId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehTypeName', label: Dict.vehTypeName.label, width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehTonName', label: Dict.vehTonName.label, width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'driverName', label: Dict.driverName.label, width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'driverMobile', label: Dict.driverMobile.label, width: 120, show: true, privacy:true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            /* { id: 'termPowerCd', label: Dict.termPowerCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'doorSensors', label: Dict.doorSensors.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'operFontColor', label: Dict.operFontColor.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'operBackColor', label: Dict.operBackColor.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'noOperFontColor', label: Dict.noOperFontColor.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'noOperBackColor', label: Dict.noOperBackColor.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'emerFontColor', label: Dict.emerFontColor.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'emerBackColor', label: Dict.emerBackColor.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'offFontColor', label: Dict.offFontColor.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'offBackColor', label: Dict.offBackColor.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'syncTime', label: Dict.syncTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
             */
            { id: 'regDate', label: "등록일", width: 120, show: true, option:{align: 'center', print:(r,i,v)=>ValueMisc.substr(v,0,10)} },
            //{ id: 'regUser', label: "regUser", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'transPosYn', label: Dict.transPosYn.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'dcCd', label: Dict.dcCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            
        ]
    },
};
